import { useMsal } from "@azure/msal-react";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { createLogger } from "../../helper/logger";

export default function LoginSuccess() {
	const navigate = useNavigate();
	const { instance, accounts } = useMsal();
	const logger = useMemo(() => createLogger("LoginSuccess"), []);

	logger.debug("MSAL instance and accounts", {
		hasInstance: !!instance,
		accountsCount: accounts?.length,
	});

	useEffect(() => {
		// Handle the redirect here
		instance
			.handleRedirectPromise()
			.then((response) => {
				// If response is non-null, it means we have response from redirect
				if (response) {
					logger.info("Successfully handled redirect", {
						tokenType: response.tokenType,
					});
					navigate("/wedge/wb-home");
				}
			})
			.catch((error) => {
				logger.error("Error handling redirect:", error);
				navigate("/login-error");
			});
	}, [instance, navigate, logger]);

	return (
		<div>
			<div>Successful Login!</div>
			<p>
				You should be redirected to the main page shortly. If not, click{" "}
				<a href="/wedge/wb-home">here</a>.
			</p>
		</div>
	);
}
